import { axios } from '../axios';

type PresingedData = {
  imageKey: string;
  presigned: {
    url: string;
    fields: {
      key: string;
      bucket: string;
      'X-Amz-Algorithm': string;
      'X-Amz-Credential': string;
      'X-Amz-Date': string;
      Policy: string;
      'X-Amz-Signature': string;
    };
  };
}[];

export const postPresingedURL = (fileTypes: string[]) =>
  axios.post<PresingedData>('/photo/presigned', { fileTypes });
